export const truncate = (str: string, max: number) =>
  str.length > max ? `${str.substring(0, max)}…` : str;
